import React, { useState, useRef } from 'react'
import { tv } from 'tailwind-variants'
import IconUse from '_/ui/icons/use'
import { useClickOutside } from '_/utils/use-click-outside'

interface SelectProps {
	options: { value: string | number; label: string }[]
	value: string | number
	onChange: (value: string | number) => void
	className?: string
}

export const dropdownIcon = tv({
	base: 'absolute -right-6 top-1/2 -translate-y-1/2 pointer-events-none ease-[cubic-bezier(0.87,_0,_0.13,_1)] transition-transform duration-300 data-[state=true]:rotate-180',
})

export const SimpleSelect: React.FC<SelectProps> = ({ options, value, onChange, className }) => {
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const selectRef = useRef<HTMLDivElement>(null)

	const handleOptionClick = (newValue: string | number) => {
		onChange(newValue)
		setIsOpen(false)
	}

	const selectedOption = options.find(option => option.value === value)

	const handleClickOutside = (event: MouseEvent) => {
		if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
			setIsOpen(false)
		}
	}

	useClickOutside(selectRef, handleClickOutside)

	return (
		<div ref={selectRef} className={`${className ? className : ''}`}>
			<div className='cursor-pointer rounded-md' onClick={() => setIsOpen(!isOpen)}>
				<span className='relative text-sm lg:text-base'>
					{selectedOption ? selectedOption.label : 'Select'}
					<IconUse id='chevron-down' width={12} height={12} data-state={isOpen} className={dropdownIcon()} />
				</span>
			</div>
			{isOpen && (
				<ul className='absolute left-0 mt-2 w-full bg-gray-100 border border-primary-light rounded-md shadow-sm max-h-40 overflow-y-auto overflow-x-hidden z-10'>
					{options.map(option => (
						<li
							key={option.value}
							className='p-2 cursor-pointer text-sm lg:text-base'
							onClick={() => handleOptionClick(option.value)}
						>
							{option.label}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
